import { Component, OnInit, TemplateRef, Inject, OnChanges ,OnDestroy} from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA,MatRadioModule } from '@angular/material';
import { DialogboxComponent } from '../dialogbox/dialogbox.component';
import { FailmodalComponent } from '../failmodal/failmodal.component';
import { Subscription } from 'rxjs';

import * as $ from 'jquery'
import { validateresponse } from '../validateresponse.model';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  // imports: [MatRadioModule]
})
export class LoginComponent implements OnInit {
     validateresponse: validateresponse = {
          state: '',
          kycdata: ''
      };
  inputValue: any="authorize";
  sessionMain: any ="";
  valueShow: boolean =false
  res: any = "";
  submitted1 = false;
  mobilno: any;
  contenthide = true;
  successcontenthide = true;
  type:string="authenticate";

  countryCode : any;
  concatNum : any;

  iphonecontenthide = true;

  mobileno: any;
  jsonstring: any = "";
  response: any;
  sessionid: any;
  id1: any;
  wrongImageResult: any;
  timeoutResult: any;
  transactionRefusedResult: any;

  authenticate_url: any = ""
  validate_url: any = ""

  loginJioID = new FormGroup({
    jioId: new FormControl()
  })

  isDisabled = true;
  isReadOnly = false;
  loading = false;
  submitted = false;
  screenW: boolean;
  validateResponse: any;

  //for timer 
  private apiTimer: any;
  private apiSubscription: Subscription;
  finalData :string= '';
  finalDataDecode :string='';
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router,
    private dialog: MatDialog
    , public dialog_1: MatDialogRef<TemplateRef<any>>, public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>, public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>,
    public dialogRef: MatDialogRef<LoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute) { dialogRef.disableClose = true; }

   

  showModal(content) {
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  modal1 = new FormGroup({
    jioId: new FormControl()
  });

  getlink(successcontent, failurecontent, content) {
    this.submitted1 = true;
    if (this.modal1.invalid) {
      document.getElementById("errormessage").style.display = "block";
    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = { "phoneno": this.modal1.value.jioId }
      this.mobilno = this.modal1.value.jioId;
      this.http.post(environment.validate, data).subscribe(
        data => {
          // console.log(data);

          this.res = data;
          if (this.res.status == "OK") {

            this.contenthide = true;
            this.successcontenthide = false;
            this.dialog_2 = this.dialog.open(successcontent, {
              panelClass: 'success-dialog-container',
              restoreFocus: true,
              role: 'dialog',
              autoFocus: false,
              disableClose: true,
              // height:'200px'
              // padding-left: '17%';
              // padding-right: '17%';

            })


          }
          else {
            // this.dialog.closeAll()
            // this.dialog_1.close();
            // this.dialog_1.afterClosed().subscribe(result => {
            //   console.log("closed dialog");

            // });
            this.contenthide = true;

            this.dialog_3 = this.dialog.open(failurecontent, {
              panelClass: 'failure-dialog-container',

              // backdropClass: 'failurebackdrop'
              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

              // }


            })
          }

          ;
        })
    }
  }

  dismissmodal() {
    this.dialog.closeAll()
    this.modal1.reset();

  }
  get f() { return this.modal1.controls; }

  openapk() {

    this.dismissmodal();
    // window.open('./assets/apk/JioID-1.0.4.apk');
    window.open(environment.androidlink);



  }

  openipapk() {
    this.dismissmodal();
    window.open(environment.iOSlink);
  }

  refreshpage() {
    location.reload();

  }

  sendphonelink1(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";

      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "0"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);

          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.contenthide = true;


            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,


            })
          }
          else {
            // this.dialog.closeAll()
            this.contenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        },
        err => {
          this.contenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        }
      )
    }
  };
  sendphonelink2(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "1"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);
          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })


          }
          else {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'custom-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        },
        err => {
          this.iphonecontenthide = true;


          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        })
    }
  }
  showModal1(successcontent) {

    this.successcontenthide = false;
    this.dialog_2 = this.dialog.open(successcontent, {
      panelClass: 'success-dialog-container',
      restoreFocus: true,
      role: 'dialog',
      autoFocus: false,
      disableClose: true,
      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })

  }
  sendandroidphonelink(content) {
    this.successcontenthide = true;
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  sendiphonelink(iphonecontent) {
    this.successcontenthide = true;

    this.iphonecontenthide = false;
    this.dialog_1 = this.dialog.open(iphonecontent, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }




  ngOnInit() {

     // Start the timer to call the API every 1 minute (60000 ms)
    //  this.apiTimer = setInterval(() => {
    //   this.validateQRapi();
    // }, 4000);

    // Optional: Call API immediately when the component loads
    //this.validateQRapi();

    sessionStorage.clear()

    // console.log(window.screen.width);
    if (window.screen.width >= 1100) {  //class=aside visibility for desktop
      this.screenW = true;
    }
    else {
      this.screenW = false;
    }

    sessionStorage.setItem("stopCall","No");
    this.loginJioID.reset();
    document.getElementById("errorQR").style.display = "none";
    document.getElementById("qrCode1").style.display = "block";
    document.getElementById("txtOR").style.display = "block";
    document.getElementById("formLogin").style.display = "none";

    document.getElementById("fail").style.display = "none";
    document.getElementById("transaction_refused").style.display = "none";
    document.getElementById("TIME_OUT").style.display = "none";

    document.getElementById("error1").style.display = "none";
    document.getElementById("error2").style.display = "none";
    document.getElementById("error3").style.display = "none";
    document.getElementById("error4").style.display = "none";
    document.getElementById("error7").style.display = "none";

    document.getElementById("errorM").style.display = "none";

    document.getElementById("invalidnumber").style.display = "none";

    // ////document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    // document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    // document.getElementById("buttonD1").style.color = "#707070";

    document.getElementById("buttonD1").style.backgroundColor = "#224797";
      document.getElementById("buttonD1").style.borderColor = "#224797";
      document.getElementById("buttonD1").style.color = "white";

    this.loginJioID = this.formBuilder.group({
      // jioId: ['', [Validators.required, Validators.pattern('^^[0-9]{10}$')]],
      jioId: ['', [Validators.required, Validators.pattern('^[0-9]*$'),Validators.minLength(4), Validators.maxLength(15)]],

    });

    this.modal1 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^^[0-9]{10}$')]]
    })
    sessionStorage.removeItem("id");

    //QR Authentication call
    this.http.post(environment.authenticate_Qr, {},{ params: {
      "type": this.type,
    
    },
  withCredentials: true},
  
   
  )
    .subscribe((res) => {
      this.response = res;
      console.log(this.response.sessionId +" hii this is res");


      sessionStorage.setItem("sessionId",this.response.sessionId);
      this.sessionid=`${sessionStorage.getItem("sessionId")}`;
      console.log("Getting sessionId"+this.sessionid)
     // this.sessionid=`${this.sessionMain}`;
      this.validate_url = environment.validate_url;
      this.validateQRapi();
      
    },
      err => {
        console.log("error",err);
      }
    );
    

  }
  handleInputField(value: any) {
    this.inputValue = value;
   // this.sessionid=`${this.sessionMain}`
    console.log(this.inputValue)
    // this.inputValue2=`${this.sessionid}/${this.inputValue}`;
    // this.valueShow= true;
    // console.log(this.inputValue);
    
    //QR Authentication call
    this.http.post(environment.authenticate_Qr, {},{ params: {
      "type": this.inputValue,
    
    },
  withCredentials: true},
  
   
  )
    .subscribe((res) => {
      this.response = res;
      console.log(this.response.sessionId +" hii this is res");


      sessionStorage.setItem("sessionId",this.response.sessionId);
      this.sessionid=`${sessionStorage.getItem("sessionId")}`;
      console.log("Getting sessionId"+this.sessionid)
     // this.sessionid=`${this.sessionMain}`;
      this.validate_url = environment.validate_url;
      //this.validateQRapi();
      
    },
      err => {
        console.log("error",err);
      }
    );
   
}

  validateQRapi(){
    //console.log(this.inputValue)
    //const type =this.inputValue;
    sessionStorage.setItem("id", "null");

    this.http.post(this.validate_url,{}, 
      {withCredentials: true}
    ).subscribe ((res)=>{
      console.log("hello");
      
        this.validateResponse=res;
        console.log('@@response123');
        console.log('@@response1234',this.validateResponse);
       console.log('@@response',this.validateResponse.kycencoded);
       this.finalData=this.validateResponse.kycencoded;
       this.finalDataDecode= atob(this.finalData);
       console.log("decode value", this.finalDataDecode);
       
       // Parse the XML string
       const parser = new DOMParser();
       const xmlDoc = parser.parseFromString(this.finalDataDecode, 'text/xml');

        // Extract the <kycRes> tag value
        const kycResElement = xmlDoc.getElementsByTagName('kycRes')[0];
        const kycResValue = kycResElement ? kycResElement.textContent : null;

        if (kycResValue) {
          console.log('KYC Response:', kycResValue);
          const decodexmlEkyc= atob(kycResValue);
          console.log("last full data:- ",decodexmlEkyc);
          sessionStorage.setItem('lastData',decodexmlEkyc);
          
        } else {
          console.error('kycRes tag not found in the response.');
        }

        this.validateresponse=this.validateResponse;
        console.log("cookie",document.cookie);
        if (this.validateResponse.state == "RUNNING") {
          if(this.router.url === '/login'){
            if(sessionStorage.getItem("stopCall") == "No"){
              console.log("enter hereeee");
              
             this.validateQRapi();

            }
          }
        }  else if (this.validateResponse.state == "COMPLETE") {
          // alert("done");
          sessionStorage.setItem("stopCall","yes");
          console.log("done");
          if(this.inputValue=="authorize")
          {
            this.router.navigateByUrl("/MyData");
          }
            else
          {
          this.router.navigateByUrl("/myTransactions");
          }
         
          // console.log("done2");
        }  else if (this.validateResponse.state == "TIMEOUT") {
          // alert("timeout");
          sessionStorage.setItem("stopCall","yes");
          console.log("timeout");
          document.getElementById("errorQR").style.display = "block";
        } else {
          sessionStorage.setItem("stopCall","yes");
          console.log("result_code",this.validateResponse.result);
        }
        this.dialog.closeAll();
      },
      err=>{
        sessionStorage.setItem("stopCall","yes");
        console.log("error",err);
      })
  }

  openDialog(data1, data2): void {
    this.dialog.open(DialogboxComponent, {
      width: '500px',
      height: '400px',
      data: { d1: data1, d2: data2 }
    });

    this.validateapi();
  }



  validateapi() {

    //valiadte call
    return this.http.post(this.validate_url, {},
      { withCredentials: true }

    ).subscribe((res) => {
      this.response = res;
      //stateus and kyc data 

      if (this.response.state == "RUNNING") {

        this.validateapi();
      } else if (this.response.state == "COMPLETE") {
        this.dialog.closeAll();
        sessionStorage.setItem("stopCall","yes");

        this.router.navigateByUrl("/myTransactions")

      } else {

        if (this.response.state == "WRONG_VC") {
          this.wrongImageResult = "Wrong image selected"
          sessionStorage.setItem("wrong_image", this.wrongImageResult)

          document.getElementById('fail').style.display = 'block';

        } else if (this.response.state == "USER_REFUSED") {
          this.transactionRefusedResult = "Transaction refused by user"
          sessionStorage.setItem("transaction_refused", this.transactionRefusedResult)

          document.getElementById('transaction_refused').style.display = 'block';
        }
        else {
          this.timeoutResult = this.response.state
          sessionStorage.setItem("TIME_OUT", this.timeoutResult)

          document.getElementById('TIME_OUT').style.display = 'block';
        }

        this.dialog.closeAll();
      }

    },
      err => {
        this.dialog.closeAll();
        if (err.error.errorCd == '0100') {
          document.getElementById('error1').style.display = 'block';
        } else if (err.error.errorCd == '0101') {
          document.getElementById('error2').style.display = 'block';
        }
        else if (err.error.errorCd == '0115') {
          document.getElementById('error3').style.display = 'block';
        }
        else if (err.error.errorCd == '0119') {
          document.getElementById('error4').style.display = 'block';
        } else if (err.error.errorCd == '0118') {
          document.getElementById('error7').style.display = 'block';
        }
        else if (err.error.errorCd == '0107') {
          document.getElementById('error6').style.display = 'block';
        }
        else {
          console.log(err.error)
          this.validateapi();
        }
      }

    );

  }
  closewrong() {

    document.getElementById('error4').style.display = 'none';
    document.getElementById('error3').style.display = 'none';
    document.getElementById('error1').style.display = 'none';
    document.getElementById('error5').style.display = 'none';
    document.getElementById('error6').style.display = 'none';
    document.getElementById('error7').style.display = 'none';

  }
  close() {


    document.getElementById('transaction_refused').style.display = 'none';

    document.getElementById('TIME_OUT').style.display = 'none';

    document.getElementById('fail').style.display = 'none';
  }
  // this.dialog.open(FailmodalComponent, {
  //   width: '500px',
  //   height:'400px'
  // });   



  loginPage() {
    // console.log("redirect to login page");
    window.location.reload();

    // this.router.navigateByUrl("/login")
  }

  enterMobile(){
    // console.log("hiii");
    sessionStorage.setItem("stopCall","yes");
    this.loginJioID.reset();
    document.getElementById("errorQR").style.display = "none";
    document.getElementById("qrCode1").style.display = "none";
    document.getElementById("txtOR").style.display = "none";
    document.getElementById("formLogin").style.display = "block";   

  }

  first() {

    document.getElementById("buttonD1").style.display = "block";


    // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    this.isDisabled = true;

    if ((this.loginJioID.value.jioId).length == 10) {
      document.getElementById("buttonD1").style.backgroundColor = "#224797";
      document.getElementById("buttonD1").style.borderColor = "#224797";
      document.getElementById("buttonD1").style.color = "white";

      this.isDisabled = false;
    }

    else {
      // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
      // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";

      this.isDisabled = true;
    }
  }

  get f1() { return this.loginJioID.controls; }

  onCountryChange(event){
    console.log("here is number " +event.dialCode);
    // localStorage.setItem("tempEvent",event.dialCode)
    this.countryCode = event.dialCode;
  }

  // telInputObject(event){
  //   console.log("here is num " + JSON.stringify(event));
  //   // alert("here is number " +event)

  // }

  getNumber(event){
    // let String cc = JSON.stringify(event).split(this.loginJioID.value.jioId);

    console.log("here is here " + JSON.stringify(event));
    console.log("here is here2 " + this.loginJioID.value.jioId);
    // this.countryCode = JSON.stringify(event).split(this.loginJioID.value.jioId);

    // console.log("temppp " +this.countryCode.concat("-"+this.loginJioID.value.jioId));

    
    
  }


  proceed() {

    this.submitted = true;
    document.getElementById("invalidnumber").style.display = "none";
    // this.loading = true;

    // stop here if form is invalid
    if (this.loginJioID.invalid) {
      document.getElementById("errorM").style.display = "block";
      // return;
    }
    else {
      this.submitted = false;
      // document.getElementById('invalidnumber').style.display = 'block';
      document.getElementById("errorM").style.display = "none";


      this.authenticate_url = environment.authenticate_url
      this.validate_url = environment.validate_url

      //get phone number from url
      let id = this.route.snapshot.paramMap.get('id');
      this.mobileno = id
      sessionStorage.setItem("id", this.loginJioID.value.jioId)
      var phonenum = sessionStorage.getItem("id");

      console.log("temppp +" +this.countryCode+"-"+this.loginJioID.value.jioId);

      if(this.countryCode == 91){
        this.concatNum = this.loginJioID.value.jioId;
      }
      else if(this.countryCode){
        this.concatNum = "+"+this.countryCode+"-"+this.loginJioID.value.jioId;
      }
      else{
        this.concatNum = this.loginJioID.value.jioId;
      }

      console.log("this.concatNum = "+this.concatNum);
      

      //Authentication call
      this.http.post(this.authenticate_url.concat(this.concatNum), {},
        {
          withCredentials: true
        },
      )
        .subscribe((res) => {
          document.getElementById('errormsg').style.display = 'none';
          this.response = res;
          // const number= this.response.verificationCode
          // console.log(this.response.verificationCode)
          //  this.id1=JSON.parse(number.replace(/^0+/, ""));
          sessionStorage.setItem('code', this.response.verificationCode)

          //generate ascii for font image
          var num = Number.parseInt(this.response.verificationCode)
          var num1 = Math.floor(num / 100);
          var num2 = num % 100;
          if (num1 > 93) {
            num1 = num1 + 33 + 104;
          }
          else {
            num1 = num1 + 33;
          }
          if (num2 > 93) {
            num2 = num2 + 33 + 104;
          }
          else {
            num2 = num2 + 33
          }

          var result1 = String.fromCharCode(num1);
          var result2 = String.fromCharCode(num2);
          this.openDialog(result1, result2);


        },
          err => {
            this.dialog.closeAll();
            if (err.error.errorCd == '0100') {
              document.getElementById('error1').style.display = 'block';
            } else if (err.error.errorCd == '0101') {
              document.getElementById('error2').style.display = 'block';
            }
            else if (err.error.errorCd == '0115') {
              document.getElementById('error3').style.display = 'block';
            }
            else if (err.error.errorCd == '0120') {
              document.getElementById('error5').style.display = 'block';
            }
            else if (err.error.errorCd == '0107') {
              document.getElementById('error6').style.display = 'block';
            }
            else if (err.error.errorCd == '0118') {
              document.getElementById('error7').style.display = 'block';
            }
            else if (err.error.errorCd == '0119') {
              if (window.matchMedia("(min-width: 1200px)").matches) {
                // The viewport is less than 768 pixels wide
                $("#loginform").css({
                  "margin-bottom": "-10%"
                })


              }
              document.getElementById('invalidnumber').style.display = 'block';
            }
            else {
              document.getElementById('errormsg').style.display = 'block';
            }

          }
        );

    }
  }


}

function startStopPolling() {
if (document.visibilityState==='visible') 
 { 
console.log(' Web Page visibility changed to visible') 
this.validateapi(); 
 } else if (document.visibilityState==='hidden') 
 { console.log('Web Application is in background!!!');
this.validateapi(); }
}
document.addEventListener('visibilitychange', startStopPolling);

